<template>
    <div
        class="relative shrink-0 self-center mx-auto overflow-hidden bg-cover bg-center rounded-sm"
        :class="imageClasses"
    >
        <BlurHash
            v-if="item.imageHash"
            :hash="item.imageHash"
            :isLoaded="isLoaded"
        />
        <img
            :loading="eagerLoad ? 'eager' : 'lazy'"
            :decoding="eagerLoad ? 'sync' : 'async'"
            :width="imageSize"
            :height="imageSize"
            class="menu-page__item-image block w-full h-full rounded-r-sm object-cover"
            :class="{ 'rounded-l-sm': imageSize !== ImageSizeEnum.LG }"
            :src="item.image + imageResizeSuffix"
            :srcset="srcSet"
            :alt="item.name"
            @load="onLoad"
        />
    </div>
</template>

<script>
import BlurHash from './BlurHash.vue';
import { ImageSizeEnum } from '@/enums';

export default {
    name: 'ItemImage',
    components: { BlurHash },
    props: {
        item: {
            type: Object,
            required: true
        },
        largeImages: {
            type: Boolean,
            required: true
        },
        eagerLoad: {
            type: Boolean,
            required: false,
            default: false
        },
        size: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            isLoaded: false,
            ImageSizeEnum,
            tailwindSizeClass: {
                1: 'w-10 h-10',
                2: 'w-11 h-11',
                3: 'w-12 h-12',
                4: 'w-14 h-14',
                5: 'w-16 h-16',
                6: 'w-20 h-20',
                7: 'w-24 h-24',
                8: 'w-28 h-28',
                9: 'w-32 h-32',
                10: 'w-36 h-36',
                11: 'w-40 h-40',
                12: 'w-44 h-44',
                13: 'w-48 h-48',
                14: 'w-52 h-52',
                15: 'w-56 h-56',
                16: 'w-60 h-60',
                17: '!w-full !h-64 rounded-t-md',
                18: '!w-full !h-72 rounded-t-md',
                19: '!w-full !h-80 rounded-t-md',
                20: '!w-full !h-96 rounded-t-md',

                [ImageSizeEnum.XS]: '!w-14 !h-14',
                [ImageSizeEnum.SM]: '!w-24 !h-24',
                [ImageSizeEnum.MD]: 'w-28 h-28',
                [ImageSizeEnum.LG]: 'w-36 h-36',
                [ImageSizeEnum.XL]: '!w-full !h-64 rounded-t-md',
                [ImageSizeEnum.XXL]: '!w-full !h-80 rounded-t-md'
            }
        };
    },
    computed: {
        imageSize() {
            let size = this.size
                ? this.size
                : ImageSizeEnum.getFromLegacyFlags(
                      this.largeImages,
                      this.isBao
                  );

            if (Object.values(ImageSizeEnum.options).includes(size)) {
                switch (size) {
                    case ImageSizeEnum.XS:
                        return 56;
                    case ImageSizeEnum.LG:
                        return 144;
                    case ImageSizeEnum.SM:
                        return 96;
                    case ImageSizeEnum.XL:
                        return 440;
                    case ImageSizeEnum.XXL:
                        return 640;
                    default:
                        return 112; // MD
                }
            }

            size = parseInt(size, 10);

            if (!isNaN(size) && size > 0 && size < 21) {
                const match = this.imageClasses.match(/!?h-(\d+)/);

                if (!match || match.length <= 1) {
                    return 112;
                }

                return parseInt(match[1], 10) * 4;
            }

            return 112;
        },
        imageClasses() {
            let size = this.size
                ? this.size
                : ImageSizeEnum.getFromLegacyFlags(
                      this.largeImages,
                      this.isBao
                  );

            return this.tailwindSizeClass[size] || this.tailwindSizeClass[8];
        },
        isBao() {
            return (
                this.$store.state.venue?.venue?.accountId ===
                '5f4e9ddc-3431-43f5-9de0-7aa356564afc'
            );
        },
        imageResizeSuffix() {
            return this.largeImages
                ? '-/resize/144x/-/format/auto/'
                : '-/resize/112x/-/format/auto/';
        },
        srcSet() {
            const base = this.item.image;
            const resize1x = this.imageSize;
            const resize2x = this.imageSize * 2;
            const resize3x = this.imageSize * 3;
            return `${base}-/resize/${resize1x}x/-/format/auto/ 1x, ${base}-/resize/${resize2x}x/-/format/auto/ 2x, ${base}-/resize/${resize3x}x/-/format/auto/ 3x`;
        }
    },
    methods: {
        onLoad() {
            this.isLoaded = true;
        }
    }
};
</script>
